import type { ContractPenaltyResponseDto, ContractPenaltyType } from '@carvia/ros-client-types';
import { httpClient } from './http-client';

class ContractPenaltiesService {
  async addContractPenalty(
    bookingId: string,
    body: { type: ContractPenaltyType; attemptDepositCharge?: boolean },
  ) {
    const res = await httpClient.post<ContractPenaltyResponseDto>(
      `/bookings/${bookingId}/contract-penalties`,
      body,
    );
    return res.data;
  }
}

export const contractPenaltiesService = new ContractPenaltiesService();
